<template>
  <div>
    <div class="row row-equal">
      <div class="flex md2 clickable--button" @click="switchComponent('campaign','adherents')">
        <va-card
          class="mb-4 clickable--button--int"
          :color="(selectedComponent==='campaign'&&filter==='adherents')?'success':'info'"
        >
          <p class="display-3 mb-0 text--center" style="color: white">Adhésions à traiter</p>
        </va-card>
      </div>
      <div class="flex md2 clickable--button" @click="switchComponent('campaign','getAll')">
        <va-card
          class="clickable--button--int mb-4"
          :color="(selectedComponent==='campaign'&&filter==='getAll')?'success':'info'"
        >
          <p class="display-4 mb-0 text--center" style="color: white">Toute entreprise prospectable</p>
        </va-card>
      </div>
      <div class="flex md2 clickable--button" @click="switchComponent('archives')">
        <va-card
          class="mb-4 clickable--button--int"
          :color="(selectedComponent==='archives')?'success':'info'"
        >
          <p class="display-3 mb-0 text--center" style="color: white">Archives</p>
        </va-card>
      </div>
      <div class="flex md2">
        <va-card class="mb-4">
          <p class="display-4 mb-0 text--center" style="color: blue">{{moyCourrierAdh}}</p>
          <p class="display-6 mb-0 text--center">Moyenne de courriers par adhésion</p>
        </va-card>
      </div>
      <div class="flex md4">
        <va-card class="mb-4">
          <div class="row row-separated text--center">
            <div class="flex md3 text--center">
              <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbAdhCourantes }}</p>
              <p class="display-8 mb-0 text--center" style="color: black">Adhésions en cours</p>
            </div>
            <div class="flex md3 text--center">
              <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbNiveau1 }}</p>
              <p class="display-8 mb-0 text--center" style="color: black">Niveau 1</p>
            </div>
            <div class="flex md3 text--center">
              <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbNiveau2 }}</p>
              <p class="display-8 mb-0 text--center" style="color: black">Niveau 2</p>
            </div>
            <div class="flex md3 text--center">
              <p class="display-4 mb-0 text--center" style="color: #40E583">{{ nbNiveau3 }}</p>
              <p class="display-8 mb-0 text--center" style="color: black">Niveau 3</p>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <dashboard-table-campaign
      v-if="selectedComponent==='campaign'"
      :syndicat="syndicat"
      :filter="filter"
    ></dashboard-table-campaign>
    <dashboard-table-archive v-if="selectedComponent==='archives'" :syndicat="syndicat"></dashboard-table-archive>
  </div>
</template>

<script>
import axios from "axios";
import DashboardTableCampaign from "./DashboardTableCampaign";
import DashboardTableArchive from "./DashboardTableArchive";
export default {
  name: "DashboardInfoBlock",
  props: ["syndicat"],
  components: { DashboardTableCampaign, DashboardTableArchive },
  data() {
    return {
      filter: "adherents",
      moyCourrierAdh: "-",
      nbAdhCourantes: "-",
      nbNiveau1: "-",
      nbNiveau2: "-",
      nbNiveau3: "-",
      selectedComponent: "campaign"
    };
  },
  created() {
    this.init();
  },

  methods: {
    switchComponent(toggle, filter) {
      this.selectedComponent = toggle;
      if (filter) {
        this.filter = filter;
      }
    },
    toProcess() {
      console.log("test");
    },
    async init() {
      try {
        let stats = await axios.get("/api/stats-entreprises-syndicat", {
          params: { syndicat: this.syndicat }
        });
        stats = stats.data;
        this.nbAdhCourantes = stats.count_ent;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.clickable--button {
  cursor: pointer;
}

.clickable--button:hover > .clickable--button--int {
  border: 1px solid #ccc;
  background-color: red;
}
</style>
